import React from 'react';
import Alert from 'components/ui/Alert';
import { useTranslation } from 'react-i18next';

export default function ContractNotApplied({ showEmptyMessage }) {
  const { t } = useTranslation();
  return (
    <Alert type="warning" title={t('CONTRACT_NOT_APPLIED')}>
      {showEmptyMessage
        ? t('EMPTY_QUICKPAY_MSG')
        : t('EMPTY_ACTIVE_QUICKPAY_MSG')}
    </Alert>
  );
}
